// Styles
const themeStyles = {
  isMobile: false,
  responsive_mobile_width: 768,
  iphone_plus_query: '@media screen and (min-device-width : 414px) and (max-device-width : 736px)',
  mobile_query: '@media screen and (max-width: 768px)',
  desktop_query: '@media screen and (min-width: 769px)',

  font_family_primary: ['Avenir LT W01_45 Book1475508', 'sans-serif'],
  font_size_primary: 20,
  font_weight_primary: 300,

  font_family_secondary: ['filson-soft', 'sans-serif'],
  font_size_secondary: 15,
  font_weight_secondary: 800,

  font_family_heading: ['Gilroy', 'sans-serif'],
  font_weight_heading: 800,
  font_size_heading: 45,

  title_grey: '#676767',

  light_background: '#F5F5F5',                    // dogshare
  dark_background: '#001227',                     // dogshare

  border_color: '#F1F1F1',

  even_table_background: '#F3F2F7',

  horizontal_rule_color: '#DDDDDD',

  purple: '#6F43D6',
  teal: '#52B9C3',
  green: '#7FFF24',
  orange: '#FF4E44',
  blue: '#2B00F7',
  baby_blue: '#56C5FF',                           // dogshare
  red: '#F10B63',
  turquoise: '#39b4d6',

  error: '#E85E5E',

  black: '#000000',
  offblack: '#141D25',                            // dogshare
  darker_grey: '#505050',
  dark_grey: '#4A4A4A',                           // dogshare
  grey: '#BFBFBF',                                // dogshare
  light_grey: '#F4F4F4',                          // dogshare
  lighter_grey: '#F8F8F8',
  white: '#FFFFFF',

  facebook: '#3B5998',

  container_width: 1170,
  margin: 15,
  navBarHeight: 80,
  tabBarHeight: 40,
  popover_distance_from_bottom: 75,

  post_text_fontSize: 14,
  post_text_lineHeight: 25,
};

const apiKeys = {
  facebook_app_id: '727162037485391',
};

const globals = {
  primary: themeStyles.baby_blue,
  secondary: themeStyles.orange,
  tertiary: themeStyles.turquoise,
};

const fonts = {
  text_color: themeStyles.darker_grey,
};

const navigation = {
  height: 80,
  zIndex: 100,
  link_fontFamily: ['Open Sans', 'sans-serif'],
  link_color: themeStyles.offblack,
  link_hover_color: globals.primary,
  link_styles: {
    fontWeight: 600,
    textDecoration: 'none',
    fontSize: 16,
  },
};

const footer = {
  height: 270,
  font_size: 15,
  backgroundColor: themeStyles.dark_background,
};

// Export all theme config, plus values dependent on those from above objects
export const Theme = Object.assign({}, themeStyles, fonts, globals, { // eslint-disable-line
  footer,
  navigation,
  apiKeys,
});



// WEBPACK FOOTER //
// ./src/config/theme.js